import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EFPicture from '@elem/ui/ef-picture';
import EcoImg from 'eco-design/base/eco-img';
import { isStatusB } from '@elem/compPage/TrailSeries/pages/product/pageStatus';
import VideoFrame from '../VideoFrame';
import Modal from '../Explore/components/Modal';
import Subscribe from '../Explore/components/Subscribe';
import SubscribeEu from '../Explore/components/SubsrcibeEu';
import styles from './index.module.scss';
import useProduct from './useProduct';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';
import Icon1 from './icons/icon1';
import Icon2 from './icons/icon2';
import Icon3 from './icons/icon3';

const ProductList: React.FC = () => {
    const { locale } = getLocal(); // 暂时注释掉未使用的变量
    const { t } = useLang('ProductList'); // 暂时注释掉未使用的变量
    const statusB = isStatusB();

    const { productList } = useProduct(locale, statusB); // 暂时注释掉未使用的变量

    const productBoxSceneRef = useRef<any>(null); // product-list-box动画场景引用

    const [isModalOpen, setIsModalOpen] = useState(false);

    const { isPad, isH5 } = useDeviceDetect();

    const [swiperKey, setSwiperKey] = useState(0); // 用于强制重新渲染Swiper
    const [activeProduct, setActiveProduct] = useState(productList[0]);

    // 滚动动画控制
    useEffect(() => {
        if (typeof window !== 'undefined' && AniContainer) {
            const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

            // 第二阶段：Swiper从底部滑入动画场景
            const productBoxScene = AniContainer.create({
                triggerElement: `.list-box-bg`,
                triggerHook: 1,
                offset: '10%', // 在视频播放快结束时开始
                duration: viewPortHeight * 0.7, // 滚动0.8个视窗高度
                easing: 'ease',
                asyncFromTo: [['.swiper-instance', { y: viewPortHeight, opacity: 0 }, { y: 0, opacity: 1 }, 1]],
            });

            productBoxSceneRef.current = productBoxScene;

            AniContainer.scrollHandle(); // 执行一次初始化

            return () => {
                if (productBoxSceneRef.current) {
                    AniContainer.removeScene(productBoxSceneRef.current);
                }
            };
        }
    }, [swiperKey]);

    const handleClick = (e: React.MouseEvent, index: number) => {
        if (index === 1) {
            handleSubscribe(e, index);
            return;
        }

        const item = productList[index];
        if (item.quantity === 0) {
            return;
        }

        // 108 buy
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            position: 'Product Preview',
            product_name: `${item.title}`,
            __btn_id1: `${styles.ProductList} .buy-${index + 1}`,
            __btn_id2: `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`,
            __btn_type: 'href',
        });
        window.open(`https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`, '_blank');
    };

    const handleSubscribe = (e: React.MouseEvent, index: number) => {
        // 107 pop_ups
        gtm.push({
            event: 'uaEvent',
            event_name: 'pop_ups',
            title_name: productList[index].title,
            button_name: 'Subscribe Now',
            __btn_id1: `${styles.ProductList} .subscribe`,
            __btn_id2: 'Subscribe Now',
            __btn_type: 'text',
        });
        setIsModalOpen(true);
        setActiveProduct(productList[index]);
    };

    const [slidesPerView, setSlidesPerView] = useState<number | 'auto'>(3);
    const [spaceBetween, setSpaceBetween] = useState(32);
    useEffect(() => {
        const newSlidesPerView = isH5 || isPad ? 'auto' : 3;
        // 只有当 slidesPerView 真正改变时才更新状态和强制重新渲染
        if (newSlidesPerView !== slidesPerView) {
            setSlidesPerView(newSlidesPerView);
            setSpaceBetween(isH5 || isPad ? 16 : 32);
            // 强制重新渲染Swiper组件
            setSwiperKey((prev) => prev + 1);
        }
    }, [isH5, isPad, slidesPerView]);

    const getSubscribeData = () => {
        return {
            sector_name: activeProduct.skuTitle,
            entry_position: 3,
        };
    };

    return (
        <div className={`${styles.ProductList} GtmModuleData-section`} data-section-id={'ProductList'} id="ProductList">
            <div className="product-list-video-box">
                <div className="product-list-inner">
                    <div className="product-list-video">
                        <VideoFrame />
                    </div>
                </div>
            </div>
            <div id="product-list-box" className="product-list-box">
                <div className="list-box-bg">
                    <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1753847450912/image%205156038%20(3)%20(1).jpg" />
                    <div className="swiper-container eco-content">
                        <div className="swiper-instance">
                            <Swiper
                                className=""
                                key={swiperKey}
                                spaceBetween={spaceBetween}
                                slidesPerView={slidesPerView}
                                observer={true} // 监视DOM变化
                                observeParents={true} // 监视父元素变化
                                watchSlidesProgress={true}
                            >
                                {productList.map((item, key: number) => (
                                    <SwiperSlide key={item.variantId}>
                                        <div className="product-list-item">
                                            <div className="top">
                                                <div className="product-img">
                                                    <EFPicture src={item.img} />
                                                </div>
                                                <div className="title">{item.skuTitle}</div>
                                                <div className="desc">{item.desc}</div>
                                            </div>
                                            <div className="params-box-line"></div>

                                            <div className="params-box">
                                                {item.params.map((param, index) => (
                                                    <div className="param-item" key={index}>
                                                        <div className="param-item-title">
                                                            <div className="param-item-title-icon">
                                                                {index === 0 && <Icon1 />}
                                                                {index === 1 && <Icon2 />}
                                                                {index === 2 && <Icon3 />}
                                                            </div>
                                                            {param}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="bottom">
                                                {statusB && (
                                                    <div className="price-box">
                                                        {item.price && <div className="price">{FormatMoneyLocal(item.price || 0, locale)}</div>}
                                                        {item.discountPrice && (
                                                            <div className="discountPrice">{FormatMoneyLocal(item.discountPrice || 0, locale)}</div>
                                                        )}
                                                    </div>
                                                )}

                                                {statusB ? (
                                                    <div
                                                        className={`buy buy-${key + 1}` + (key !== 1 && item.quantity <= 0 ? ' disabled' : '')}
                                                        onClick={(e) => handleClick(e, key)}
                                                    >
                                                        {key === 1 ? t('subscribe_now') : item.quantity <= 0 ? t('sold_out') : t('buy_now')}
                                                    </div>
                                                ) : (
                                                    <div className={'buy subscribe GtmModuleData-btn-text'} onClick={(e) => handleSubscribe(e, key)}>
                                                        {t('subscribe_now')}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <div className="footer-desc">{t('footer_desc')}</div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal visible={isModalOpen} onClose={() => setIsModalOpen(false)}>
                {['us', 'ca', 'ph'].includes(locale) ? <Subscribe /> : <SubscribeEu activeProduct={activeProduct} getSubscribeData={getSubscribeData} />}
            </Modal>
        </div>
    );
};

export default ProductList;
